import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import ConfirmModal from './ConfirmModal';

const ROLES = [
    { value: 'yonetim', label: 'Yönetim (tam yetki)' },
    { value: 'admin', label: 'Admin (API Entegrasyonu ve Kullanıcılar hariç)' },
    { value: 'finansci', label: 'Finansçı' }
];
// Rol seviyeleri: finansci/destek < admin < yonetim < master_admin
const roleLevel = (r) => ({ destek: 1, finansci: 1, admin: 2, yonetim: 3, master_admin: 4 }[r] || 0);
const LEGACY_LABELS = { yardimci: 'Yardımcı (eski)', izleyici: 'İzleyici (eski)', destek: 'Destek (eski)', master_admin: 'Master Admin' };

const roleLabel = (r) => (ROLES.find(x => x.value === r) || {}).label || LEGACY_LABELS[r] || r;

const ManagementUsersPage = () => {
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    const myRole = currentUser.role;
    const myLevel = roleLevel(myRole);
    // Atanabilir roller: yalnızca kendi seviyene kadar
    const assignableRoles = ROLES.filter(r => roleLevel(r.value) <= myLevel);

    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({ username: '', password: '', role: 'finansci', canDeposit: true, canWithdraw: true });
    const [editingId, setEditingId] = useState(null);
    const [confirmState, setConfirmState] = useState({ open: false, message: '', onConfirm: null, danger: false });
    const askConfirm = (message, onConfirm, danger = false) => setConfirmState({ open: true, message, onConfirm, danger });
    const closeConfirm = () => setConfirmState({ open: false, message: '', onConfirm: null, danger: false });

    const fetchUsers = useCallback(async () => {
        try {
            const res = await api.getManagementUsers();
            setUsers(res.data);
        } catch (error) {
            console.error('Yönetim kullanıcıları çekilemedi', error);
        }
    }, []);

    useEffect(() => {
        document.title = 'PayzoPay - Yönetim Kullanıcıları';
        fetchUsers();
    }, [fetchUsers]);

    const resetForm = () => { setForm({ username: '', password: '', role: 'finansci', canDeposit: true, canWithdraw: true }); setEditingId(null); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingId) {
                const payload = { role: form.role, canDeposit: form.canDeposit, canWithdraw: form.canWithdraw };
                if (form.password && form.password.trim() !== '') payload.password = form.password;
                await api.updateManagementUser(editingId, payload);
            } else {
                await api.createManagementUser(form);
            }
            resetForm();
            fetchUsers();
        } catch (error) {
            alert('İşlem başarısız: ' + (error.response?.data?.error || error.message));
        }
    };

    const handleEdit = (u) => {
        setEditingId(u._id);
        setForm({ username: u.username, password: '', role: u.role, canDeposit: !!u.canDeposit, canWithdraw: !!u.canWithdraw });
    };

    const handleDelete = async (id) => {
        try {
            await api.deleteManagementUser(id);
            fetchUsers();
        } catch (error) {
            alert('Silme başarısız: ' + (error.response?.data?.error || error.message));
        }
    };

    const inputStyle = { width: '100%', padding: '8px', marginBottom: '10px', boxSizing: 'border-box', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)', border: '1px solid var(--input-border)', borderRadius: '4px' };

    return (
        <div style={{ padding: '20px', color: 'var(--text-color)' }}>
            <h2>Yönetim Kullanıcıları</h2>

            <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                {/* Form */}
                <div style={{ flex: '0 0 320px', background: 'var(--card-bg)', padding: '20px', borderRadius: '8px', boxShadow: 'var(--shadow)' }}>
                    <h3 style={{ marginTop: 0 }}>{editingId ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı'}</h3>
                    <form onSubmit={handleSubmit}>
                        <label>Kullanıcı Adı</label>
                        <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} disabled={!!editingId} required style={inputStyle} />
                        <label>Şifre {editingId && <span style={{ fontSize: '0.8em', opacity: 0.7 }}>(boş bırakılırsa değişmez)</span>}</label>
                        <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required={!editingId} style={inputStyle} />
                        <label>Rol</label>
                        <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} style={inputStyle}>
                            {assignableRoles.map(r => (
                                <option key={r.value} value={r.value}>{r.label}</option>
                            ))}
                        </select>
                        {form.role === 'yardimci' && (
                            <div style={{ marginBottom: '10px', padding: '10px', border: '1px solid var(--input-border)', borderRadius: '4px' }}>
                                <div style={{ fontSize: '0.9em', marginBottom: '6px', opacity: 0.8 }}>Yardımcı işlem izinleri:</div>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', cursor: 'pointer' }}>
                                    <input type="checkbox" checked={form.canDeposit} onChange={e => setForm({ ...form, canDeposit: e.target.checked })} /> Yatırım işlemleri
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                    <input type="checkbox" checked={form.canWithdraw} onChange={e => setForm({ ...form, canWithdraw: e.target.checked })} /> Çekim işlemleri
                                </label>
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                            <button type="submit" style={{ flex: 1, padding: '10px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>{editingId ? 'Kaydet' : 'Oluştur'}</button>
                            {editingId && <button type="button" onClick={resetForm} style={{ padding: '10px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>İptal</button>}
                        </div>
                    </form>
                </div>

                {/* Liste */}
                <div style={{ flex: 1, minWidth: '320px', background: 'var(--card-bg)', padding: '20px', borderRadius: '8px', boxShadow: 'var(--shadow)' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', borderBottom: '2px solid var(--border-color)' }}>
                                <th style={{ padding: '8px' }}>Kullanıcı</th>
                                <th style={{ padding: '8px' }}>Rol</th>
                                <th style={{ padding: '8px' }}>İzinler</th>
                                <th style={{ padding: '8px', textAlign: 'right' }}>İşlem</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length === 0 ? (
                                <tr><td colSpan="4" style={{ padding: '12px', textAlign: 'center', opacity: 0.7 }}>Kayıt yok.</td></tr>
                            ) : users.map(u => {
                                const canManageThis = roleLevel(u.role) <= myLevel;
                                return (
                                    <tr key={u._id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                                        <td style={{ padding: '8px' }}>{u.username}</td>
                                        <td style={{ padding: '8px' }}>{roleLabel(u.role)}</td>
                                        <td style={{ padding: '8px', fontSize: '0.85em' }}>
                                            {u.role === 'yardimci' ? `${u.canDeposit ? 'Yatırım' : ''}${u.canDeposit && u.canWithdraw ? ' + ' : ''}${u.canWithdraw ? 'Çekim' : ''}${!u.canDeposit && !u.canWithdraw ? '-' : ''}` : '-'}
                                        </td>
                                        <td style={{ padding: '8px', textAlign: 'right' }}>
                                            {canManageThis ? (
                                                <>
                                                    <button onClick={() => handleEdit(u)} style={{ marginRight: '6px', padding: '5px 10px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Düzenle</button>
                                                    <button onClick={() => askConfirm(`${u.username} kullanıcısını silmek istediğinize emin misiniz?`, () => handleDelete(u._id), true)} style={{ padding: '5px 10px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Sil</button>
                                                </>
                                            ) : (
                                                <span style={{ fontSize: '0.8em', opacity: 0.6 }}>Yetkiniz yok</span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <ConfirmModal
                open={confirmState.open}
                message={confirmState.message}
                danger={confirmState.danger}
                onConfirm={() => { if (confirmState.onConfirm) confirmState.onConfirm(); closeConfirm(); }}
                onCancel={closeConfirm}
            />
        </div>
    );
};

export default ManagementUsersPage;
